import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./pontos.component.html')
})
export class PontosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/pontos.component.ts
 **/